import { Action } from '@ngrx/store';

import { MergedHotelviewResponseModel } from '../../../../shared/models/hotelview/merged-response.model';
import { HotelviewDataIdAttributes } from '../../../../shared/models/hotelview/data-id-attributes.model';
import { CustomerTab } from '../../../xena-tabs/shared/models/customer-tab.model';



export const LOAD_HOTELVIEW_DATA_SUCCESS = '[XENA] LOAD_HOTELVIEW_DATA_SUCCESS';
export const LOAD_HOTELVIEW_DATA_ERROR = '[XENA] LOAD_HOTELVIEW_DATA_ERROR';

export const SET_ACTIVE_HOTELVIEW = '[XENA] SET_ACTIVE_HOTELVIEW';

export const EXPAND_HOTELVIEW_PANEL = '[XENA] EXPAND_HOTELVIEW_PANEL';
export const COLLAPSE_HOTELVIEW_PANEL = '[XENA] COLLAPSE_HOTELVIEW_PANEL';
export const TOGGLE_HOTELVIEW_PANEL_DONE = '[XENA] TOGGLE_HOTELVIEW_PANEL_DONE';

export const OPEN_HOTELVIEW_DIALOG = '[XENA] OPEN_HOTELVIEW_DIALOG';
export const CLOSE_HOTELVIEW_DIALOG = '[XENA] CLOSE_HOTELVIEW_DIALOG';

export const INIT_HOTELVIEW_TABS = '[XENA] INIT_HOTELVIEW_TABS';



export class LoadHotelviewDataSuccess implements Action {
	readonly type = LOAD_HOTELVIEW_DATA_SUCCESS;

	constructor(public params: HotelviewDataIdAttributes, public payload: MergedHotelviewResponseModel) {}
}

export class LoadHotelviewDataError implements Action {
	readonly type = LOAD_HOTELVIEW_DATA_ERROR;

	constructor(public descriptionProvider: string) {}
}

export class SetActiveHotelview implements Action {
	readonly type = SET_ACTIVE_HOTELVIEW;

	constructor(public payload: HotelviewDataIdAttributes) {}
}

export class ExpandHotelviewPanel implements Action {
	readonly type = EXPAND_HOTELVIEW_PANEL;
}

export class CollapseHotelviewPanel implements Action {
	readonly type = COLLAPSE_HOTELVIEW_PANEL;
}

export class ToggleHotelviewPanelDone implements Action {
	readonly type = TOGGLE_HOTELVIEW_PANEL_DONE;
}

export class OpenHotelviewDialog implements Action {
	readonly type = OPEN_HOTELVIEW_DIALOG;
}

export class CloseHotelviewDialog implements Action {
	readonly type = CLOSE_HOTELVIEW_DIALOG;
}

export class InitHotelviewTabs implements Action {
	readonly type = INIT_HOTELVIEW_TABS;

	constructor(public payload: Array<CustomerTab>) {}
}


export type All
	= LoadHotelviewDataSuccess
	| LoadHotelviewDataError
	| SetActiveHotelview
	| ExpandHotelviewPanel
	| CollapseHotelviewPanel
	| ToggleHotelviewPanelDone
	| OpenHotelviewDialog
	| CloseHotelviewDialog
	| InitHotelviewTabs;



// WEBPACK FOOTER //
// ./src/app/xena/core/state-management/actions/hotelview.ts